<template>
  <a-modal title="Actualización de datos"
           :visible="visible"
           @ok="confirmar"
           :confirmLoading="modalLoading"
           @cancel="cancelar">
    <a-form :form="form" @submit="confirmar">

      <a-form-item label="Identificación" v-bind="fiOptions">
        <a-input :disabled="true" v-model="profile.identificacion">
        </a-input>
      </a-form-item>

      <a-form-item label="Celular" v-bind="fiOptions">
        <a-input-number
          v-decorator="['celular', { rules: [
                            { required: true, message: 'Valor requerido' },
                            { type: 'integer', message: 'Debe ser numérico' },
                            { type: 'integer', min: 1000000000, max: 999999999999999, message:'Debe tener entre 10 y 15 dígitos'}
                          ] }]"
          :disabled="modalLoading || ($getConfigValue('BLOQUEAR_CELULAR_DASHBOARD', 'NO') === 'SI')"
          style="width: 100%">
        </a-input-number>
      </a-form-item>

      <a-form-item label="Email Personal" v-bind="fiOptions">
        <a-input
          v-decorator="['email_personal', { rules: [
                          { required: true, message: 'Valor requerido' },
                          { pattern: modalPattern, message: 'Debe ser un correo válido.' }]
                        }
                          ]"
          :disabled="modalLoading || ($getConfigValue('BLOQUEAR_EMAIL_PERSONAL_DASHBOARD', 'NO') === 'SI')">
        </a-input>
      </a-form-item>

      <a-form-item label="Dirección" v-bind="fiOptions">
        <a-textarea placeholder="Dirección"
                    readOnly
                    autoSize
                    :disabled="$getConfigValue('BLOQUEAR_DIRECCION_DASHBOARD', 'NO') === 'SI'"
                    v-decorator="['direccion', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                    v-on:click="modalDireccionVisible = true">
        </a-textarea>
      </a-form-item>

      <a-alert type="error" :message="mensajeError" v-if="error"/>
    </a-form>
    <div v-if="visible_foto_perfil_ss">
      <div style="text-align: right">
        <a-upload
          name="avatar"
          list-type="picture-card"
          class="actualizarDatos"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          style="color: red">
          <div v-if="imageUrl">
            <img :src="imageUrl" alt="avatar" style="width: 150px; height: 200px;"/>
          </div>
          <div v-else>
            <div class="ant-upload-text">
              Cambiar Foto de Perfil
            </div>
          </div>
        </a-upload>
        <a-button v-if="imageUrl" type="primary" @click="guardarFotoPerfil">Guardar Imagen</a-button>
        <br/>
        <a href="https://compressjpeg.com/es/" target="_blank">Comprimir Imagenes</a>
      </div>
    </div>
    <direccion-estructurada v-model="direccion" :visible="modalDireccionVisible"
                            @cancel="modalDireccionVisible = false"
                            @success="direccionCambiada"></direccion-estructurada>
  </a-modal>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        visible_foto_perfil_ss: this.$getConfigValue('VISIBLE_FOTO_PERFIL_SS', 'SI') === 'SI',
        modalLoading: false,
        error: false,
        mensajeError: '',
        modalPattern: '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])',
        form: this.$form.createForm(this, {
          name: 'solicitar'
        }),
        fiOptions: {
          'label-col': {span: 10},
          'wrapper-col': {span: 14},
          'has-feedback': true
        },
        direccion: '',
        modalDireccionVisible: false,
        uploadedPicture: null,
        imageUrl: ''
      }
    },
    props: ['visible', 'profile'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.httpClientUploader = this.httpClient.getNewInstance()
      this.httpClientUploader.defaults.headers['Content-Type'] = 'multipart/form-data'
    },
    methods: {
      cancelar () {
        if (this.modalLoading) return
        this.modalLoading = false
        this.$emit('cancel')
      },
      confirmar (e) {
        e && e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            this.modalLoading = true
            console.log(values)

            this.httpClient.getInstance().post('ss/update_profile', values)
              .then((response) => {
                if (parseInt(response.data.response) === 0) {
                  this.error = true
                  this.mensajeError = response.data.mensaje
                } else {
                  this.error = false
                  this.mensajeError = ''
                  this.modalVisible = false
                  Mensajes.success('Correcto', response.data.mensaje)
                  this.form.resetFields()
                  this.$emit('success', {})
                }
              })
              .catch((error) => {
                Mensajes.error('Error', 'No fue posible realizar la solicitud.')
                this.error = true
              })
              .then(() => {
                this.modalLoading = false
              })
          }
        })
        this.isInSubmit = false
      },
      direccionCambiada () {
        this.modalDireccionVisible = false
        this.form.setFieldsValue({direccion: this.direccion})
      },
      beforeUpload (file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isJpgOrPng) {
          this.$message.error('You can only upload JPG file!')
          return false
        }
        const isLt2M = file.size / 1024 < 512
        if (!isLt2M) {
          this.$message.error('Image must smaller than 512 KB!')
          return false
        }

        this.uploadedPicture = file

        const reader = new FileReader()
        reader.addEventListener('load', () => {
          this.imageUrl = reader.result
        })
        reader.readAsDataURL(file)

        return false
      },
      guardarFotoPerfil () {
        if (this.modalLoading) {
          return
        }
        this.modalLoading = true

        let request = new FormData()
        request.append('picture', this.uploadedPicture)

        this.httpClientUploader.post('picture_service/upload/profile', request)
          .then((response) => {
            if (parseInt(response.data.response) === 0) {
              this.error = true
              this.mensajeError = response.data.mensaje
            } else {
              this.error = false
              this.mensajeError = ''
              this.modalVisible = false
              Mensajes.success('Correcto', response.data.mensaje)
              this.form.resetFields()
              this.$emit('success', {})
            }
          })
          .catch((error) => {
            Mensajes.error('Error', 'No fue posible realizar la solicitud.')
            this.error = true
          })
          .then(() => {
            this.modalLoading = false
          })
      }
    },
    watch: {
      visible () {
        if (this.visible) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              celular: parseInt(this.profile.celular),
              email_personal: this.profile.email_personal,
              direccion: this.profile.direccion
            })
            this.direccion = this.profile.direccion
          })
        }
      }
    }
  }
</script>
<style>
  .actualizarDatos > .ant-upload.ant-upload-select-picture-card {
    float: right !important;
  }
</style>


// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/ModalActualizarDatos.vue